// R-102 (B-172, Round 3 lane 1): typed start and end dates for Choose dates on tablet and desktop. Phones keep the native
// picker (FilterBar). A date is read when the person leaves the field or presses Enter; a bad, past or reversed date gets a
// plain line and changes nothing.
import { useState } from 'react'
import { f2 } from '../../copyFlow2'
import { r3t } from '../../copyR3Times'
import { checkTypedRange, typedOf } from '../../lib/typedDate'

export function TypedDates({ from, to, today, onPick }: { from: string; to: string; today: string; onPick: (from: string, to: string) => void }) {
  const [a, setA] = useState(typedOf(from))
  const [b, setB] = useState(typedOf(to))
  const [err, setErr] = useState<string | null>(null)
  // dates applied from elsewhere (a chip, a reset) show here; React's "adjust state on a prop change" pattern, no effect
  const [seen, setSeen] = useState(`${from}|${to}`)
  if (seen !== `${from}|${to}`) { setSeen(`${from}|${to}`); setA(typedOf(from)); setB(typedOf(to)) }
  const commit = (fa = a, fb = b) => {
    if (!fa.trim() && !fb.trim()) { setErr(null); return }
    if (!fa.trim()) return // the end typed first: wait for the start
    const c = checkTypedRange(fa, fb, today)
    if (!c.ok) { setErr(c.why === 'order' ? r3t('r3t.date_order') : c.why === 'past' ? r3t('r3t.date_past') : r3t('r3t.date_bad')); return }
    setErr(null)
    setA(typedOf(c.from))
    setB(typedOf(c.to))
    onPick(c.from, c.to ?? '')
  }
  const field = (id: 'from' | 'to', label: string, v: string, set: (s: string) => void) => (
    <label className="block">
      <span className="t-caption mb-1 block text-ink-2">{label}</span>
      <input type="text" inputMode="numeric" autoComplete="off" data-review-id={`typed-date-${id}`} placeholder={r3t('r3t.date_hint')} value={v}
        aria-invalid={Boolean(err)} onChange={(e) => set(e.target.value)} onBlur={() => commit()}
        onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); commit() } }}
        className="t-body min-h-11 w-full rounded-[12px] bg-surface px-3 ring-1 ring-inset ring-boundary/60" />
    </label>
  )
  return (
    <div className="mt-3 grid grid-cols-2 gap-3">
      {field('from', f2('filter.start_date'), a, setA)}
      {field('to', f2('filter.end_date'), b, setB)}
      {err && <p role="alert" className="t-meta col-span-2 text-error">{err}</p>}
    </div>
  )
}
